import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, onMounted, onUnmounted } from 'vue'
import { useGolfHeaderStore } from '@/store/golf-header'
import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'
import GolfTripInfoSection from './GolfTripInfoSection.vue'
import { useGolfTripsStore } from '@/store/golf-trips'
import { useGolfI18n } from '@/composables/useGolfI18n'
import type { GolfTrip } from '@/api/golf'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props

const golfStore = useGolfTripsStore()
const headerStore = useGolfHeaderStore()
const { t } = useGolfI18n()

const trip = ref<GolfTrip | null>(null)
const error = ref<string | null>(null)

const loadTrip = async () => {
  error.value = null
  try {
    const result = await golfStore.fetchTrip(props.id)
    trip.value = result
  } catch (e: any) {
    error.value = e?.message || t('golf.trips.no_trips_found')
  }
}

onMounted(() => {
  headerStore.setHeaderInfo(t('golf.trips.trip_details'), false)
  headerStore.setCustomHeader(true)
  loadTrip()
})

onUnmounted(() => {
  headerStore.setCustomHeader(false)
})

return (_ctx: any,_cache: any) => {
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "container"
  }, {
    default: _withCtx(() => [
      (error.value)
        ? (_openBlock(), _createBlock(CommonError, {
            key: 0,
            errorMessage: error.value,
            onRetryPress: loadTrip
          }, null, 8, ["errorMessage"]))
        : (!trip.value)
          ? (_openBlock(), _createBlock(Loader, { key: 1 }))
          : (_openBlock(), _createBlock(GolfTripInfoSection, {
              key: 2,
              trip: trip.value,
              onRefresh: loadTrip
            }, null, 8, ["trip"]))
    ]),
    _: 1
  }))
}
}

})